import { TComment } from "apiTypes";
import useTranslation from "next-translate/useTranslation";
import { cloneElement } from "react";
import styled from "styled-components";
import { fromNow } from "utils/fromNow";
import { profileAvatar } from "../../../config";
type Props = {
  data: TComment | null;
  children?: any;
  isLast: boolean;
  isReply?: boolean;
  hasReplies?: boolean;
  setReplyTab?: (comment: TComment) => void;
  isAdmin?: boolean;
};
const Comment = ({
  data,
  children,
  isLast,
  isReply,
  hasReplies,
  isAdmin,
  setReplyTab,
}: Props) => {
  const { t } = useTranslation();

  const commentClass = () => {
    if (!isReply) {
      if (isLast) {
        return "border-none mb-3";
      } else if (hasReplies) {
        return "border-none mb-0";
      } else {
        return "border-bottom mb-3";
      }
    } else {
      if (isLast) {
        return "border-bottom mb-3 ps-5";
      } else {
        return "border-none mb-0 ps-5";
      }
    }
  };
  return (
    <>
      <div className={`comment ${commentClass()}`}>
        <div className="d-flex justify-content-between align-items-center px-2">
          <div className="d-flex">
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img
              className="rounded-circle"
              src={data?.commenter?.avatar?.original || profileAvatar}
              alt={data?.commenter?.name}
              width="42"
              style={{ width: 48, height: 48 }}
            />
            <div className="w-100 ms-2">
              <div className="bg-secondary rounded px-3 py-2">
                <div className="d-flex justify-content-between align-items-center gap-3">
                  <h4 className="fs-sm mb-0 text-capitalize ">
                    {data?.commenter?.name}
                  </h4>
                  {data?.commenter.admin && (
                    <StatusBadge color="info">{t("support_team")}</StatusBadge>
                  )}
                </div>

                <p className="mb-0 text-break lh17">{data?.content}</p>
              </div>
              <div className="d-flex  align-items-center gap-2">
                {isAdmin && (
                  <span
                    className="fs-xs text-primary mt-2 d-block cursor"
                    onClick={() => setReplyTab(data)}
                  >
                    {t("add_reply")}
                  </span>
                )}
                <span className="fs-xs text-muted mt-2 d-block">
                  {fromNow(data?.created_at)}
                </span>
              </div>
            </div>
          </div>

          {children &&
            cloneElement(children, {
              auth_comment: data?.auth_comment,
              isAdmin: isAdmin,
              id: data?.id,
            })}
        </div>
      </div>
    </>
  );
};

export default Comment;
const StatusBadge = styled.div`
  padding: 0.2rem 0.5rem;
  font-size: 0.7rem;
  border-radius: 0.25rem;
  color: ${(props) => `var(--${props.color})`};
  background-color: ${(props) => `var(--${props.color}-bg)`};
`;
